<template>
  <div class="chart-container">
    <canvas ref="canvas" class="canvas-graph"></canvas>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs";

Chart.defaults.global.legend.display = false;

import ChartSettings from "./chart.settings.js";

import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.defaults.global.plugins.datalabels.anchor = "end";
Chart.defaults.global.plugins.datalabels.align = "end";

import moment from "moment";

export default {
  extends: Bar,
  data() {
    return {
      labels: [],
      new_data: [],
      returning_data: []
    };
  },
  props: {
    inside: Array,
    preorder: Array,
    delivery: Array
  },
  watch: {
    inside() {
      this.rerender();
    }
  },
  methods: {
    createDataset() {
      if (this.inside.length <= 7) {
        this.labels = this.inside.map(d =>
          moment(d.timestamp, "DD.MM.YYYY").format("ddd")
        );
      } else {
        this.labels = this.inside.map(d => d.timestamp);
      }

      this.new_data = this.inside.map((item, index) => {
        return (
          this.inside[index].new_clients +
          this.preorder[index].new_clients +
          this.delivery[index].new_clients
        );
      });

      this.returning_data = this.inside.map((item, index) => {
        return (
          this.inside[index].returning_clients +
          this.preorder[index].returning_clients +
          this.delivery[index].returning_clients
        );
      });
    },
    rerender() {
      this.createDataset();
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              data: this.new_data,
              backgroundColor: "#129B81"
            },
            {
              data: this.returning_data,
              backgroundColor: "#194F44"
            }
          ]
        },
        {
          // hover:false,
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                // stacked: true,
                // categoryPercentage: 0.5,
                // barPercentage: 1,
                gridLines: { zeroLineColor: "#ededed", zeroLineWidth: 2, z: 4 }
              }
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  callback: function(value) {
                    if (value % 1 === 0) {
                      return value;
                    }
                  }
                },
                // stacked: true,
                gridLines: { zeroLineColor: "#ededed", zeroLineWidth: 2, z: 4 }
              }
            ]
          }
        }
      );
    }
  },
  mounted() {
    this.addPlugin(ChartDataLabels);
    this.rerender();
  }
};
</script>

<style scoped>
.canvas-graph {
  background: #1d1d1b;
  width: 75vh !important;
  height: 50vh !important;
  padding-top: 5vh;
  border-radius: 0 0 1vh 1vh;
}

.chart-container {
  width: min-content;
  display: block;
}
</style>